var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "onboarding-summary" },
    [
      _c("OnboardingSteps", { attrs: { "current-step": "summary" } }),
      _c("div", { staticClass: "onboarding-content" }, [
        _c("div", { staticClass: "onboarding-header" }, [
          _c("div", { staticClass: "onboarding-header-content" }, [
            _c("h1", { staticClass: "onboarding-header-title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.$t("onboarding.summary.title", {
                      count: _vm.totalConnectedPages,
                    })
                  ) +
                  "\n        "
              ),
            ]),
            _c("p", { staticClass: "onboarding-header-subtitle" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("onboarding.summary.subtitle")) +
                  "\n        "
              ),
            ]),
          ]),
        ]),
        _vm.hasExceededPageQuota
          ? _c("div", { staticClass: "onboarding-quota-warning" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "20",
                    height: "20",
                    viewBox: "0 0 20 20",
                    fill: "none",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M10 6V10M10 14H10.01M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                ]
              ),
              _c("div", [
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.$t("onboarding.connect_pages.quota_status")) +
                      ": " +
                      _vm._s(_vm.totalConnectedPages) +
                      "/" +
                      _vm._s(_vm.userPlanPageQuota)
                  ),
                ]),
                _c("p", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t("onboarding.connect_pages.quota_exceeded")
                      ) +
                      "\n          " +
                      _vm._s(_vm.$t("onboarding.summary.quota_action_delete")) +
                      "\n        "
                  ),
                ]),
                _c("p", { staticClass: "quota-info" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("onboarding.connect_pages.quota_upgrade_info")
                    )
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _c("div", { staticClass: "onboarding-search-bar" }, [
          _c(
            "svg",
            {
              staticClass: "search-icon",
              attrs: {
                width: "18",
                height: "18",
                viewBox: "0 0 18 18",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("circle", {
                attrs: {
                  cx: "8",
                  cy: "8",
                  r: "6",
                  stroke: "#9CA3AF",
                  "stroke-width": "2",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M12.5 12.5L16 16",
                  stroke: "#9CA3AF",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
            ]
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchQuery,
                expression: "searchQuery",
              },
            ],
            staticClass: "search-input",
            attrs: {
              type: "text",
              placeholder: _vm.$t("onboarding.summary.search_placeholder"),
            },
            domProps: { value: _vm.searchQuery },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.searchQuery = $event.target.value
              },
            },
          }),
        ]),
        _c("div", { staticClass: "onboarding-table-container" }, [
          _c("table", { staticClass: "onboarding-table" }, [
            _c("thead", [
              _c("tr", [
                _c("th", { staticClass: "col-avatar" }),
                _c(
                  "th",
                  {
                    staticClass: "col-name",
                    on: {
                      click: function ($event) {
                        return _vm.sortBy("name")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("onboarding.summary.table_header_name")) +
                        "\n              "
                    ),
                    _vm.sortColumn === "name"
                      ? _c("span", { staticClass: "sort-indicator" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.sortDirection === "asc" ? "▲" : "▼") +
                              "\n              "
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
                _c(
                  "th",
                  {
                    staticClass: "col-network",
                    on: {
                      click: function ($event) {
                        return _vm.sortBy("network")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t("onboarding.summary.table_header_network")
                        ) +
                        "\n              "
                    ),
                    _vm.sortColumn === "network"
                      ? _c("span", { staticClass: "sort-indicator" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.sortDirection === "asc" ? "▲" : "▼") +
                              "\n              "
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
                _c(
                  "th",
                  {
                    staticClass: "col-status",
                    on: {
                      click: function ($event) {
                        return _vm.sortBy("APIStatus")
                      },
                    },
                  },
                  [
                    _vm.sortColumn === "APIStatus"
                      ? _c("span", { staticClass: "sort-indicator" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.sortDirection === "asc" ? "▲" : "▼") +
                              "\n              "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t("onboarding.summary.table_header_api_status")
                        ) +
                        "\n            "
                    ),
                  ]
                ),
                _c(
                  "th",
                  {
                    staticClass: "col-status",
                    on: {
                      click: function ($event) {
                        return _vm.sortBy("nativeStatus")
                      },
                    },
                  },
                  [
                    _vm.sortColumn === "nativeStatus"
                      ? _c("span", { staticClass: "sort-indicator" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.sortDirection === "asc" ? "▲" : "▼") +
                              "\n              "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t(
                            "onboarding.summary.table_header_native_status"
                          )
                        ) +
                        "\n            "
                    ),
                  ]
                ),
                _c("th", { staticClass: "col-actions" }, [
                  _vm._v(
                    _vm._s(_vm.$t("onboarding.summary.table_header_actions"))
                  ),
                ]),
              ]),
            ]),
            _c(
              "tbody",
              _vm._l(_vm.filteredPages, function (page) {
                return _c(
                  "tr",
                  {
                    key: `${page.network}-${page.id}`,
                    staticClass: "table-row",
                  },
                  [
                    _c("td", { staticClass: "col-avatar" }, [
                      page.avatar && !_vm.imageLoadErrors[page.id]
                        ? _c("img", {
                            staticClass: "page-avatar",
                            attrs: { src: page.avatar, alt: page.name },
                            on: {
                              error: function ($event) {
                                return _vm.handleImageError(page.id)
                              },
                            },
                          })
                        : _c(
                            "div",
                            { staticClass: "page-avatar avatar-placeholder" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(page.name.charAt(0).toUpperCase()) +
                                  "\n              "
                              ),
                            ]
                          ),
                    ]),
                    _c("td", { staticClass: "col-name" }, [
                      _vm._v(_vm._s(page.name)),
                    ]),
                    _c("td", { staticClass: "col-network" }, [
                      _c("div", { staticClass: "network-badge" }, [
                        _c("img", {
                          staticClass: "network-icon",
                          attrs: {
                            src: _vm.getNetworkIcon(page.network),
                            alt: page.network,
                          },
                        }),
                        _c("span", [
                          _vm._v(_vm._s(_vm.getNetworkName(page.network))),
                        ]),
                      ]),
                    ]),
                    _c("td", { staticClass: "col-status" }, [
                      _c(
                        "span",
                        {
                          staticClass: "status-badge",
                          class: page.apiConnected
                            ? "connected"
                            : "not-connected",
                        },
                        [
                          _c("span", { staticClass: "status-dot" }),
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                page.apiConnected
                                  ? _vm.$t(
                                      "onboarding.summary.status_connected"
                                    )
                                  : _vm.$t(
                                      "onboarding.summary.status_not_connected"
                                    )
                              ) +
                              "\n              "
                          ),
                        ]
                      ),
                    ]),
                    _c("td", { staticClass: "col-status" }, [
                      !_vm.supportsNativeConnection(page.network)
                        ? _c("span", { staticClass: "group-empty" }, [
                            _vm._v("—"),
                          ])
                        : _c(
                            "span",
                            {
                              staticClass: "status-badge",
                              class: page.nativeConnected
                                ? "connected"
                                : "not-connected",
                            },
                            [
                              _c("span", { staticClass: "status-dot" }),
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    page.nativeConnected
                                      ? _vm.$t(
                                          "onboarding.summary.status_connected"
                                        )
                                      : _vm.$t(
                                          "onboarding.summary.status_not_connected"
                                        )
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                    ]),
                    _c("td", { staticClass: "col-actions" }, [
                      _c(
                        "button",
                        {
                          staticClass: "delete-btn",
                          attrs: {
                            title: _vm.$t(
                              "onboarding.summary.delete_page_title"
                            ),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.removePageFromOnboarding(page)
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M2 4h12M5.5 4V2.5A1.5 1.5 0 0 1 7 1h2a1.5 1.5 0 0 1 1.5 1.5V4m2 0v9.5A1.5 1.5 0 0 1 11 15H5a1.5 1.5 0 0 1-1.5-1.5V4h9Z",
                                  stroke: "currentColor",
                                  "stroke-width": "1.5",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm.filteredPages.length === 0
            ? _c("div", { staticClass: "empty-state" }, [
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("onboarding.summary.empty_state"))),
                ]),
              ])
            : _vm._e(),
        ]),
        _c("div", { staticClass: "onboarding-footer-container" }, [
          _c("div", { staticClass: "onboarding-footer" }, [
            _c(
              "button",
              {
                staticClass: "onboarding-btn-primary",
                attrs: { disabled: !_vm.canFinish },
                on: { click: _vm.finishOnboarding },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("onboarding.summary.finish_button")) +
                    "\n        "
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }